/**
 * 清算額 (円) の「支払 / 受取」の区別。
 *
 * 清算額は JEPX (eSLJ) の符号のまま運ばれる: **負 = 会員が支払う、 正 = 会員が受け取る**
 * (`proto/bff/bffuser/v1/jepx_settlement_model.proto` `JepxSettlement.amount_yen`)。
 * 画面は金額を**絶対値**で出し、 支払・受取は金額の左に「支払」「受取」の**文字**で示す
 * (色だけに頼らない。 Des 判断、 issue #9261 / spec `bidding/jepx-settlement.md` AC-JST-001)。
 * 0 円はどちらでもないので文字を付けない。
 *
 * `amountYen` は int64 (`bigint`) のまま扱う。 `Number` に落とすと 2^53 超で桁が欠ける。
 */
export type SettlementDirection = 'pay' | 'receive' | 'none'

export type SettlementAmountView = {
  direction: SettlementDirection
  /** 金額の絶対値 (円)。 */
  absoluteYen: bigint
}

export function toSettlementAmountView(
  amountYen: bigint,
): SettlementAmountView {
  if (amountYen < 0n) {
    return { direction: 'pay', absoluteYen: -amountYen }
  }
  if (amountYen > 0n) {
    return { direction: 'receive', absoluteYen: amountYen }
  }
  return { direction: 'none', absoluteYen: 0n }
}
